let bonzaiCounter = 0

export const getQueryPrefix = () => `bonzai-${bonzaiCounter++}`
